"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GSA_STRATEGIST_TEMPLATES = exports.GSA_STRATEGIST_TEMPLATES_MD = void 0;
exports.GSA_STRATEGIST_TEMPLATES_MD = {
    'Initial Strategy Meeting (ISM)': `* Introductions - Strategist & Client\n
* Goal Alignment\n
* Assessing Candidacy\n
* Assessing Narrative\n
* Timeline & Next Steps`,
    'Roadmap Meeting': '* N/A',
    'NAY: Meeting': 'N/A',
    'AY: Progress Check-in': 'N/A',
    'AY: Timeline & Requirements': 'N/A',
    'AY: Program Research & Selection': 'N/A',
    'AY: CV Support': 'N/A',
    'AY: Writing Support': 'N/A',
    'AY: Interview Prep': 'N/A',
    'AY: Offers Review': 'N/A',
    'AY: Other Meeting': 'N/A',
    Other: '* N/A',
};
exports.GSA_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions - Strategist & Client',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Assessing Candidacy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Assessing Narrative',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Timeline & Next Steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Roadmap Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Progress Check-in': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Timeline & Requirements': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Program Research & Selection': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: CV Support': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Writing Support': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Interview Prep': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Offers Review': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Other Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=gsa-strategist.js.map